export class FormBundleTestingToolApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async createFormBundleTestingTool(body) {
    return this.#http.post('/FormBundleTestingTool', body);
  }

  async createFormBundleTestingToolPdf(body) {
    return this.#http.post('/FormBundleTestingTool/pdf', body, { responseType: 'blob' });
  }
}
